import React from 'react';

export default function FontAwesomeIcon({
  style,
  name,
  family,
  fontSize = '34px',
  color,
}: {
  style?: string;
  name?: string;
  family?: string;
  fontSize?: string;
  color?: string;
}) {
  const className = ['fa', style, name, family].filter(Boolean).join(' ');

  return (
    <i className={className} style={{ fontSize, color }} aria-hidden="true" />
  );
}
